import { products } from '../../../../../../libs/products'
import {
  ProductSubscription,
  SubscriptionCategory,
  UpdateSubscriptionsBody,
} from './types'

// сервисные уведомления (system, margin_call) клиент отключать не может
export const SYSTEM_TYPE = 'system'

export const formatCategoryLabel = (category: string): string => {
  const text = category.replace(/_/g, ' ').trim()

  if (!text) return ''

  return text[0].toUpperCase() + text.slice(1)
}

export const formatProductLabel = (product: string): string => {
  const known = products.find(
    (item: { value: string; text: string }) => item.value === product,
  )

  return known ? known.text : formatCategoryLabel(product)
}

export type SubscriptionGroup = {
  type: string
  items: SubscriptionCategory[]
}

// группируем по Type, сохраняя порядок появления типов в ответе бэка
export const groupByType = (
  subscriptions: SubscriptionCategory[],
): SubscriptionGroup[] =>
  subscriptions.reduce((groups: SubscriptionGroup[], subscription) => {
    const group = groups.find((item) => item.type === subscription.Type)

    if (group) {
      group.items.push(subscription)
    } else {
      groups.push({ type: subscription.Type, items: [subscription] })
    }

    return groups
  }, [])

export const buildUpdateBody = (
  item: ProductSubscription,
  draft: SubscriptionCategory[],
): UpdateSubscriptionsBody => ({
  userId: item.clientId,
  product: item.product,
  subscriptions: draft.map((subscription) => ({
    category: subscription.Category,
    type: subscription.Type,
    isActive: subscription.IsActive,
  })),
})
